<template>
  <div>
    <PageHeader title="Manage Service Configurations" icon="settings" :subtitle="description" />
    <Subheader v-model="search" title="Service Configurations" search="configurations" />
    <v-card v-for="configuration in filteredConfigurations" :key="configuration.id" class="mb-1 configuration-card">
      <v-card-title style="padding: 10px;">
        <span class="title">{{ configuration.name }}</span>
      </v-card-title>
      <!-- <v-card-text style="padding: 10px;">
        <b>Export format</b>
        : {{ configuration.exportFormat }}
      </v-card-text> -->
      <v-card-actions>
        <ViewDialog :form="form" :configuration="configuration" @fetchConfigurations="$emit('fetchConfigurations')" />
        <ScheduleDialog :form="form" :configuration="configuration" @fetchConfigurations="$emit('fetchConfigurations')"/>
      </v-card-actions>
    </v-card>
    <v-container v-if="configurations.length == 0">
      <p>

        <v-icon color="info" class="pr-2" style="line-height: 19px;">error_outline</v-icon>This place is empty.
        Create a configuration and it will show up here!
      </p>
    </v-container>
  </div>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const serviceconfigurations = createNamespacedHelpers('serviceconfigurations')

  import ViewDialog from './ViewDialog'
  import ScheduleDialog from './ScheduleDialog'
  import {
    filterMixin,
  } from '../Helpers/Filter'
  export default {
    components: {
      ViewDialog,
      ScheduleDialog,
    },
    mixins: [filterMixin],
    props: {
      form: Function,
      configurations: Array,
    },
    data() {
      return {
        search: '',
        navItems: [{
          text: 'Manage Services',
          disabled: false,
          to: {
            name: 'manageservices',
          },
          exact: true,
        },
        {
          text: 'Tenant Configurations',
          disabled: true,
        },
        ],
      }
    },
    computed: {
      ...serviceconfigurations.mapGetters(['currentService']),      
      description() {
        return `Manage configurations for ${this.currentService.DisplayName}.`
      },
      filteredConfigurations() {
        return this.filterList(this.configurations, this.search)
      },
    },
    methods: {      
      view(id) {
        this.$emit('view', id)
      },
      
    },
  }
</script>

<style>
  @media only screen and (min-width: 519px) {
    .configuration-card .v-btn+div+.v-btn {
      margin-left: 8px;
    }
  }

  @media only screen and (max-width: 519px) {
    .configuration-card .v-card__actions .v-btn+.v-btn {
      margin-left: 0px !important;
    }

    .configuration-card .v-btn {
      width: 100%;
    }

    .configuration-card .pl-3 {
      padding-left: 8px !important;
    }
  }
</style>